import { render, staticRenderFns } from "./board_add_new_column_trigger.vue.js?vue&type=template&id=39aa296e&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_add_new_column_trigger.vue?vue&type=template&id=39aa296e&vue3"
import script from "./board_add_new_column_trigger.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_add_new_column_trigger.vue?vue&type=script&lang=js&vue3"
export * from "./board_add_new_column_trigger.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_add_new_column_trigger.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports